<div class="select" #selectContainer>
  <!-- Label and required text row -->
  <div class="select__header">
    <label class="select__label">
      {{ label() }}
      @if (required()) {
        <span class="select__required-indicator">*</span>
      }
    </label>
    @if (required()) {
      <p class="select__required-text">
        {{ requiredText() }}
      </p>
    }
  </div>

  <!-- Select trigger (clickable area) -->
  <div
    class="select__trigger"
    [class.select__trigger--placeholder]="isPlaceholder()"
    [class.select__trigger--error]="showError()"
    [class.select__trigger--disabled]="disabled()"
    (click)="toggleDropdown()"
    (keydown)="onTriggerKeyDown($event)"
    [attr.tabindex]="disabled() ? -1 : 0"
    role="combobox"
    [attr.aria-disabled]="disabled()"
    [attr.aria-expanded]="isDropdownOpen()"
    [attr.aria-haspopup]="true">
    <span class="select__trigger-text">{{ displayText() | translate }}</span>
    <i class="bi bi-caret-down-fill select__trigger-icon"></i>
  </div>

  <!-- Dropdown positioned below or above the trigger -->
  <div
    class="select__dropdown-wrapper"
    [class.select__dropdown-wrapper--above]="dropdownOpenAbove()">
    <app-dropdown
      #dropdown
      [items]="options()"
      [isOpen]="isDropdownOpen()"
      [selectedItem]="selectedItem()"
      [maxHeight]="dropdownMaxHeight()"
      [openAbove]="dropdownOpenAbove()"
      [searchable]="searchable()"
      [searchPlaceholder]="searchPlaceholder()"
      (itemSelected)="onItemSelected($event)"
      (closed)="closeDropdown()">
    </app-dropdown>
  </div>

  <!-- Error message -->
  @if (showError() && errorMessage()) {
    <p class="select__error-message">
      {{ errorMessage() }}
    </p>
  }
</div>
